export const flexLayout1 = {
    name: 'layout1',
    cols: [
        {
            col: 0,
            flex: '25'
        },
        {
            col: 1,
            flex: '25'
        },
        {
            col: 2,
            flex: '50'
        }
    ],
    rows: [
        {row: 0, class: 'row-class0 super-duper'},
        {row: 1, class: 'row-class1'},
        {row: 2, class: 'row-class2'},
        {row: 3, class: 'row-class3'},
        {row: 4, class: 'row-class4'},
        {row: 5, class: 'row-class5'}
    ],
    fields: [
        {
            fieldName: 'image1',
            col: 0,
            row: 0,
            rowspan: 4,
            width: '320px',
            minWidth: '320px',
            maxWidth: '320px'
        },
        {
            fieldName: 'text1',
            col: 1,
            row: 0,
            colspan: 2,
            maxCollapsedWidth: 0,
            class: 'super-deper'
        },
        {
            fieldName: 'label1',
            col: 1,
            row: 1,
            colspan: 2,
            layoutAlign: 'start center',
            class: 'margin-left-5'
        },
        {
            fieldName: 'select1',
            col: 1,
            row: 2,
            maxCollapsedWidth: 0,

        },
        {
            fieldName: 'number1',
            col: 2,
            row: 2,
            maxCollapsedWidth: 0
        },
        {
            fieldName: 'text4',
            col: 1,
            row: 3,
            colspan: 2,
            maxCollapsedWidth: 0
        },
        {
            fieldName: 'text5',
            col: 0,
            row: 4,
            maxCollapsedWidth: 0
        },
        {
            fieldName: 'select23',
            col: 1,
            row: 4,
            maxCollapsedWidth: 0
        },
        {
            fieldName: 'text6',
            col: 2,
            row: 4,
            maxCollapsedWidth: 0
        },
        {
            fieldName: 'button1',
            col: 0,
            row: 5,
            colspan: 3,
            layoutAlign: 'end center'
        }
    ]
};
